import {
  emailColumnDefinition,
  firstNameColumnDefinition,
  activeFlagColumnDefinition,
  lastNameColumnDefinition,
  ssoColumnDefinition,
  expirationDateColumnDefinition,
  lastLoginColumnDefinition,
  expirationSsoName,
  expirationUpdatedOnColumnDefinition,
} from '../columnDefinitions';
import CheckboxCellRenderer from '../agGrid/cellRenderers/checkboxCellRenderer.component';
import ExpirationDateUpdateCellRender from '../cellRenderers/expirationDateUpdateCellRenderer';

type ColumnDefinitionsType = {
  handleSelect: (option: number) => void;
  selectedUsers: number[];
  editedUsers: number[];
  isDisabled: (value: number) => boolean;
};

const defaultOrderedColumns = [
  emailColumnDefinition,
  firstNameColumnDefinition,
  lastNameColumnDefinition,
  ssoColumnDefinition,
  activeFlagColumnDefinition,
];

export const defaultColumDeinitions = [
  ...defaultOrderedColumns,
  {
    ...expirationDateColumnDefinition,
    cellRenderer: ExpirationDateUpdateCellRender(),
  },
  expirationSsoName,
];

export const getColumDefinitions = ({
  handleSelect,
  selectedUsers,
  editedUsers,
  isDisabled,
}: ColumnDefinitionsType) => [
  {
    headerName: '',
    field: 'id',
    cellRenderer: CheckboxCellRenderer(),
    cellRendererParams: {
      isChecked: (value: number) => selectedUsers.includes(value),
      onSelect: handleSelect,
      isDisabled,
    },
    width: 50,
    minWidth: 50,
  },
  ...defaultOrderedColumns,
  {
    ...expirationDateColumnDefinition,
    cellRenderer: ExpirationDateUpdateCellRender(),
    cellRendererParams: {
      isEdited: (value: number) => editedUsers.includes(value),
    },
  },
  {
    ...lastLoginColumnDefinition,
    headerName: 'User Last Login',
  },
  expirationSsoName,
  {
    ...expirationUpdatedOnColumnDefinition,
    headerName: 'Expiration Updated On',
  },
];
